import { Card } from '@nextui-org/react';
import Image from 'next/image';
import Link from 'next/link';

export default function DuaCard({
  name,
  id,
  path,
  arabicName,
}: {
  name?: string | null;
  id: string;
  path: string;
  arabicName?: string | null;
}) {
  const imageSrc = [62, 63, 64, 65, 66, 67, 68].includes(parseInt(id))
    ? `/images/duas/${id}.png`
    : `/images/duas/dua.png`;

  return (
    <Link className="justify-center md:w-full w-full md:m-2" href={`/dua/${path}`} scroll={false}>
      <div className="flex">
        <Card isHoverable isPressable className="justify-center h-40 md:m-4 m-2 text-center">
          <div className="flex flex-row ">
            {/* {coverLoading && (
                <Skeleton
                  inline
                  className="w-full h-36 leading-none m-2"
                  count={1}
                  // height={100}
                  width={100}
                />
              )} */}
            <Image alt="book" className="rounded-full ml-4 m-2" height={100} src={imageSrc} width={100} />
            {/* <BlurringImage img={img} svg={svg} /> */}
            <div className="w-full my-auto px-2">
              {/* <Skeleton className="rounded-md w-full h-full" count={1} height={100} /> */}
              <div className="font-bold sm:text-2xl text-xl text-center">{name}</div>
              <div className="font-bold text-2xl text-center font-hafs">{arabicName}</div>
              {/* <p className="font-semibold sm:text-base text-sm">{author.split('(')[0]}</p> */}
              {/* <p>
                  {author.split('(')[1] && '('}
                  {author.split('(')[1]}
                </p> */}
            </div>
          </div>
        </Card>
      </div>
    </Link>
  );
}
